import { z } from 'zod';
import { COUNTRIES } from '../constants/countries';

export const COUNTRY_CODES = new Set(COUNTRIES.map((c) => c.code));

export const SignupSchema = z
  .object({
    full_name: z
      .string()
      .trim()
      .min(5, 'Full name must be at least 5 characters.')
      .max(60, 'Full name is too long')
      .regex(/^[\p{L} .'-]+$/u, "Full name may contain letters, spaces, hyphens, and apostrophes only"),
    username: z
      .string()
      .trim()
      .min(5, 'Username must be at least 5 characters')
      .max(30, 'Username is too long')
      .regex(/^[a-zA-Z0-9._]+$/, 'Username may include letters, numbers, dot, and underscore only'),
    email: z.string().trim().email('Please provide a valid email address.'),
    password: z
      .string()
      .min(8, 'Password must be at least 8 characters')
      .max(100, 'Password is too long')
      .refine((v) => /[a-z]/.test(v), 'Password must include at least one uppercase letter, one lowercase letter, and one special symbol')
      .refine((v) => /[A-Z]/.test(v), 'Password must include at least one uppercase letter, one lowercase letter, and one special symbol')
      .refine((v) => /[^a-zA-Z0-9]/.test(v), 'Password must include at least one uppercase letter, one lowercase letter, and one special symbol'),
    sex: z.enum(['Male', 'Female', 'Other'], { message: 'Please select a gender' }),
    date_of_birth: z
      .string()
      .refine((v) => {
        if (!v) return false;
        const d = new Date(v);
        if (Number.isNaN(d.getTime())) return false;
        const today = new Date();
        const minAgeDate = new Date(today.getFullYear() - 13, today.getMonth(), today.getDate());
        const oldestAllowed = new Date(1900, 0, 1);
        return d <= minAgeDate && d >= oldestAllowed;
      }, 'You must be at least 13 years old and to provide a valid date'),
    country_code: z
      .string()
      .refine((code) => COUNTRY_CODES.has(code), 'Please select a country from the list'),
    agree: z.literal(true, { errorMap: () => ({ message: 'You must agree to the Terms & Conditions' }) }),
    invite_token: z.string().optional(),
  })
  .strict();
